import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const FOOTER_TEXTS = {
  en:      { loc: 'Singapore',  supported: 'Supported by PIER71', privacy: 'Privacy', terms: 'Terms' },
  zh:      { loc: '新加坡',     supported: 'PIER71 支持',         privacy: '隐私',    terms: '条款' },
  'zh-TW': { loc: '新加坡',     supported: 'PIER71 支持',         privacy: '隱私',    terms: '條款' },
  fr:      { loc: 'Singapour',  supported: 'Soutenu par PIER71',  privacy: 'Confidentialité', terms: 'Conditions' },
  de:      { loc: 'Singapur',   supported: 'Unterstützt von PIER71', privacy: 'Datenschutz', terms: 'Bedingungen' },
  ja:      { loc: 'シンガポール', supported: 'PIER71 支援',       privacy: 'プライバシー', terms: '利用規約' },
  ko:      { loc: '싱가포르',   supported: 'PIER71 지원',         privacy: '개인정보', terms: '약관' },
  ar:      { loc: 'سنغافورة',  supported: 'بدعم من PIER71',      privacy: 'الخصوصية', terms: 'الشروط' },
};

function Footer() {
  const { language } = useLanguage();
  const year = new Date().getFullYear();
  const t = FOOTER_TEXTS[language] || FOOTER_TEXTS.en;

  return (
    <footer className="ed-footer">
      <div className="f-line">
        <span>© {year} <b>Fleet Intellistream Pte. Ltd.</b></span>
        <span aria-hidden="true">·</span>
        <span>{t.loc}</span>
        <span aria-hidden="true">·</span>
        <a href="https://pier71.sg/" target="_blank" rel="noopener noreferrer">{t.supported}</a>
        <span aria-hidden="true">·</span>
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">{t.privacy}</a>
        <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">{t.terms}</a>
      </div>
    </footer>
  );
}

export default Footer;
